import { NavItemType } from "shared/Navigation/NavigationItem";
import ncNanoId from "utils/ncNanoId";

export const MEGAMENU_TEMPLATES: NavItemType[] = [
  {
    id: ncNanoId(),
    href: "/",
    name: "Home Page",
    children: [
      { id: ncNanoId(), href: "/", name: "Home 1" },
      { id: ncNanoId(), href: "/", name: "Home 2", isNew: true },
      { id: ncNanoId(), href: "/", name: "Header 1" },
      { id: ncNanoId(), href: "/", name: "Header 2", isNew: true },
      { id: ncNanoId(), href: "/", name: "Coming Soon" },
    ],
  },
];

export const NAVIGATION_DEMO_2: NavItemType[] = [
  {
    id: ncNanoId(),
    href: "/page-search",
    name: "3D Printing",
    type: "megaMenu",
    children: [
      {
        id: ncNanoId(),
        href: "/printers",
        name: "Printers",
        children: [
          { id: ncNanoId(), href: "/printers", name: "Bambu Lab Printers" },
          { id: ncNanoId(), href: "/printers", name: "View All Printers" },
        ],
      },
      {
        id: ncNanoId(),
        href: "/filaments",
        name: "Filaments",
        children: [
          { id: ncNanoId(), href: "/filaments?search=PLA", name: "PLA Filaments" },
          { id: ncNanoId(), href: "/filaments?search=PETG", name: "PETG Filaments" },
          { id: ncNanoId(), href: "/filaments?search=ABS", name: "ABS/ASA Filaments" },
          { id: ncNanoId(), href: "/filaments", name: "View All Filaments" },
        ],
      },
      {
        id: ncNanoId(),
        href: "/spare-parts",
        name: "Spare Parts",
        children: [
          { id: ncNanoId(), href: "/spare-parts?search=Nozzle", name: "Hotends & Nozzles" },
          { id: ncNanoId(), href: "/spare-parts?search=Extruder", name: "Extruders" },
          { id: ncNanoId(), href: "/spare-parts", name: "View All Parts" },
        ],
      },
      {
        id: ncNanoId(),
        href: "/printers",
        name: "Featured",
        children: [
          { id: ncNanoId(), href: "/printers", name: "Best Sellers" },
          { id: ncNanoId(), href: "/offers", name: "Special Offers" },
        ],
      },
    ],
  },
  {
    id: ncNanoId(),
    href: "/robotics",
    name: "Robotics",
    type: "megaMenu",
    children: [
      {
        id: ncNanoId(),
        href: "/robotics-arms",
        name: "Robotic Arms",
        children: [
          { id: ncNanoId(), href: "/robotics-arms?search=myCobot", name: "myCobot Series" },
          { id: ncNanoId(), href: "/robotics-arms?search=mechArm", name: "mechArm Series" },
          { id: ncNanoId(), href: "/robotics-arms?search=myPalletizer", name: "myPalletizer Series" },
          { id: ncNanoId(), href: "/robotics-arms", name: "View All Arms" },
        ],
      },
      {
        id: ncNanoId(),
        href: "/robotics-pets",
        name: "Robotic Pets",
        children: [
          { id: ncNanoId(), href: "/robotics-pets?search=MarsCat", name: "MarsCat" },
          { id: ncNanoId(), href: "/robotics-pets?search=MetaCat", name: "MetaCat" },
          { id: ncNanoId(), href: "/robotics-pets", name: "View All Pets" },
        ],
      },
      {
        id: ncNanoId(),
        href: "/robotics-humanoids",
        name: "Humanoids",
        children: [
          { id: ncNanoId(), href: "/robotics-humanoids?search=Mercury", name: "Mercury Series" },
          { id: ncNanoId(), href: "/robotics-humanoids", name: "View All Humanoids" },
        ],
      },
      {
        id: ncNanoId(),
        href: "/robotics-accessories",
        name: "Featured",
        children: [
          { id: ncNanoId(), href: "/robotics-accessories?search=Kit", name: "AI Kits" },
          { id: ncNanoId(), href: "/robotics-accessories", name: "View All Gear" },
        ],
      },
    ],
  },
  {
    id: ncNanoId(),
    href: "/accessories",
    name: "Accessories",
    type: "megaMenu",
    children: [
      {
        id: ncNanoId(),
        href: "/accessories",
        name: "3D Printing",
        children: [
          { id: ncNanoId(), href: "/accessories?search=Plate", name: "Build Plates" },
          { id: ncNanoId(), href: "/accessories?search=Nozzle", name: "Hotends & Nozzles" },
          { id: ncNanoId(), href: "/accessories?search=AMS", name: "AMS Accessories" },
          { id: ncNanoId(), href: "/accessories?search=Tool", name: "Maintenance Tools" },
          { id: ncNanoId(), href: "/accessories", name: "View All 3D" },
        ],
      },
      {
        id: ncNanoId(),
        href: "/robotics-accessories",
        name: "Robotics",
        children: [
          { id: ncNanoId(), href: "/robotics-accessories?search=Gripper", name: "Grippers & Suction" },
          { id: ncNanoId(), href: "/robotics-accessories?search=Camera", name: "Camera Modules" },
          { id: ncNanoId(), href: "/robotics-accessories?search=Base", name: "Bases & Holders" },
          { id: ncNanoId(), href: "/robotics-accessories?search=Kit", name: "AI & Vision Kits" },
          { id: ncNanoId(), href: "/robotics-accessories", name: "View All Robotics" },
        ],
      },
      {
        id: ncNanoId(),
        href: "/accessories",
        name: "More Gear",
        children: [
          { id: ncNanoId(), href: "/accessories?search=Tube", name: "PTFE Tubes" },
          { id: ncNanoId(), href: "/accessories?search=Adhesive", name: "Adhesives" },
          { id: ncNanoId(), href: "/accessories?search=Storage", name: "Storage Solutions" },
        ],
      },
    ],
  },
  {
    id: ncNanoId(),
    href: "/support",
    name: "Support",
    type: "dropdown",
    children: [
      { id: ncNanoId(), href: "/buyers-guide", name: "Buying Guide" },
      { id: ncNanoId(), href: "/warranty", name: "Warranty & Return" }, 
      { id: ncNanoId(), href: "https://innovatorsforge.com/programs/affiliate", name: "Affiliate Program", target: "_blank" },
      { id: ncNanoId(), href: "https://innovatorsforge.com/programs/co-create", name: "Co-create Program", target: "_blank" },
      { id: ncNanoId(), href: "/contact", name: "Contact Us" },
    ],
  },
  {
    id: ncNanoId(),
    href: "/company",
    name: "iForge",
    type: "dropdown",
    children: [
      { id: ncNanoId(), href: "https://academy.innovatorsforge.com", name: "iForge Academy", target: "_blank" },
      { id: ncNanoId(), href: "https://makerstore.innovatorsforge.com", name: "MakerStore", target: "_blank" },
      { id: ncNanoId(), href: "https://innovatorsforge.com/quoter/slice", name: "3D Quotes", target: "_blank" },
      { id: ncNanoId(), href: "https://innovatorsforge.com/about", name: "About Us", target: "_blank" },
      { id: ncNanoId(), href: "/contact", name: "Contact Us" },
    ],
  },
];
